import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import routeConfiguration from '../../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../../util/routes';
import css from './Sections.module.css';

function VisitSupplierSection() {
  const history = useHistory();
  return (
    <div className={css.trustedSupplierSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.trustedSupplierInfo}>
          <h2>
            <FormattedMessage id="LandFindingPage.VisitSupplierSection.title" />
          </h2>
          <p>
            <FormattedMessage id="LandFindingPage.VisitSupplierSection.description" />
          </p>
          <PrimaryButton
            className={css.trustedSupplierBtn}
            type="button"
            onClick={() =>
              history.push(
                createResourceLocatorString('TrustedSuppliersPage', routeConfiguration(), {}, {})
              )
            }
          >
            <FormattedMessage id="LandFindingPage.VisitSupplierSection.button" />
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default VisitSupplierSection;
